// export const API_BASE_URL = typeof process !== undefined ? 'http://localhost:8181' : 'https://api.bodapro.app' //192.168.1.3:8001
// export const API_BASE_URL = (typeof process === 'undefined' && window.location.hostname === 'online.bodapro.app') || window?.bodapro?.env !== 'development'  || window?.location?.port !== '3000' ? 'https://api.bodapro.app' : 'http://192.168.100.8:8181';  //192.168.1.3:8001
export const API_BASE_URL = (typeof process === 'undefined' && window.location.hostname === 'online.bodapro.app') || window?.location?.port !== '3000' ? 'https://api.bodapro.app' : 'http://192.168.100.213:8181';  //192.168.1.3:8001
export const BASE_URL = 'https://api.bodapro.app';
// export const EXTENSION_ASSETS_URL = typeof process !== undefined ? 'http://localhost:8282' : 'https://extends.bodapro.app' //
// export const EXTENSION_ASSETS_URL = (typeof process === 'undefined' && window.location.hostname === 'online.bodapro.app') || window?.bodapro?.env !== 'development' || window?.location?.port !== '3000'  ? 'https://extends.bodapro.app' : 'http://192.168.100.8:8282';  //
export const EXTENSION_ASSETS_URL = (typeof process === 'undefined' && window.location.hostname === 'online.bodapro.app') || window?.location?.port !== '3000' ? 'https://extends.bodapro.app' : 'http://192.168.100.220:8282';  //

// export const DOWNLOAD_ASSETS_URL = (typeof process === 'undefined' && window.location.hostname === 'online.bodapro.app') || window?.bodapro?.env !== 'development'  || window?.location?.port !== '3000'  ? 'https://downloads.bodapro.app' : 'http://192.168.100.8:8383';  //
export const DOWNLOAD_ASSETS_URL = (typeof process === 'undefined' && window.location.hostname === 'online.bodapro.app') || window?.location?.port !== '3000' ? 'https://downloads.bodapro.app' : 'http://192.168.100.220:8383';  //

const axios = require('axios');

export function getAxios(token, options) {
    let tokenHeader = {};
    if (token !== null && token !== undefined) {
        tokenHeader = { 'Authorization': 'Bearer ' + token };
    }

    const instance = axios.create({
        baseURL: options?.assetsURL ? options?.assetsURL : API_BASE_URL,
        timeout: 10000, //10seconds
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            ...tokenHeader
        },
        transformRequest: [function (data, headers) {
            return data;
        }],
    });

    return instance;

}


export const makeAuthRequest = async (email, password) => {
    try {
        const instance = getAxios();

        //@TODO: add logic for offline
        if (bodapro.platformType === 'desktop' && bodapro?.runMode === 'offline') {
            const row = await bodapro.dbQuery(`SELECT * FROM users WHERE email = "${email}" AND password = "${password}"`);
            return row ? row[0] : null;
        }
        console.log({ email, password });
        const res = await instance.post('/accounts/login', JSON.stringify({ email, password }));
        return res.data;
    } catch (e) {
        console.log(e);
        return null;
    }

}

export const makeGoogleAuthRequest = async (token, tokenType = 'id_token', redirectUri = null) => {
    try {
        const instance = getAxios();

        //@TODO: add logic for offline
        if (bodapro.platformType === 'desktop' && bodapro?.runMode === 'offline') {
            // For offline mode, Google OAuth won't work
            return null;
        }
        
        // Determine if request is from desktop app
        const isDesktop = bodapro.platformType === 'desktop';
        
        console.log('Google OAuth request with', tokenType, 'isDesktop:', isDesktop);
        let payload;
        
        if (tokenType === 'authorization_code') {
            // For authorization code, send it to backend to exchange for tokens.
            // redirect_uri must match the Google auth request exactly.
            payload = { 
                authorization_code: token,
                is_desktop: isDesktop,
                ...(redirectUri ? { redirect_uri: redirectUri } : {})
            };
        } else if (tokenType === 'id_token') {
            payload = { 
                id_token: token,
                is_desktop: isDesktop
            };
        } else {
            payload = { 
                access_token: token,
                is_desktop: isDesktop
            };
        }
            
        const res = await instance.post('/accounts/google-login/', JSON.stringify(payload));
        return res.data;
    } catch (e) {
        console.log('Google OAuth error:', e);
        return null;
    }
}

/**
 * Exchange a refresh token for a new access token.
 *
 * Returns { access, refresh? } on success.
 * Returns { error: 'invalid' } when the server rejected the refresh token (expired/blacklisted).
 * Returns { error: 'network' } when the server could not be reached (don't log the user out).
 */
export const refreshAuthToken = async (refresh) => {
    if (!refresh) return { error: 'invalid' };
    try {
        const instance = getAxios();
        const res = await instance.post('/accounts/token/refresh/', JSON.stringify({ refresh }));
        return res.data;
    } catch (e) {
        console.log('refreshAuthToken error:', e);
        if (e?.response?.status) {
            return { error: 'invalid', status: e.response.status };
        }
        return { error: 'network' };
    }
}

export const getCurrentUser = async (token) => {
    if (!token) {
        throw new Error('Missing authentication token');
    }

    const instance = getAxios(token);
    const res = await instance.get('/accounts/me/');
    return res.data;
};

export const updateCurrentUser = async (token, payload) => {
    if (!token) {
        throw new Error('Missing authentication token');
    }

    const instance = getAxios(token);
    const res = await instance.patch('/accounts/me/', JSON.stringify(payload));
    return res.data;
};

export const fetchUserExtensions = async (token) => {
    try {
        console.log('typeof process:', typeof process);
        if (typeof process !== 'undefined') {
            return [];
        }

        const instance = getAxios(token);
        const res = await instance.get('/extensions/user-extensions/');
        console.log('res', res);
        return res.data;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export const installUserExtension = async (token, payload) => {
    try {
        const instance = getAxios(token);
        const res = await instance.post(
            '/extensions/user-extensions/',
            JSON.stringify(payload),
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return res.data;
    } catch (e) {
        console.log('installUserExtension error', e);
        throw e;
    }
}

export const uninstallUserExtension = async (token, extensionId) => {
    try {
        const instance = getAxios(token);
        const res = await instance.delete('/extensions/user-extensions/', {
            params: {
                extension_id: extensionId,
            },
        });
        return res.data;
    } catch (e) {
        console.log('uninstallUserExtension error', e);
        throw e;
    }
}

export const getExtensions = async (search = '', tag = '') => {
    // `search` is the free-text filter (maps to the API `label` param);
    // `tag` pins a variant (maps to the API `tag` param). Base app sends no tag.
    try {
        const instance = getAxios();
        const params = new URLSearchParams();
        if (search) params.set('label', search);
        if (tag) params.set('tag', tag);
        const qs = params.toString();
        const resp = await instance.get('/extensions/extensions/' + (qs ? `?${qs}` : ''));
        return resp.data
    } catch (e) {
        return []
    }
}

export const fetchExtensionInfo = async (name) => {
    if (!name) return null;
    try {
        const instance = getAxios();
        const res = await instance.get(`/extensions/info/?name=${encodeURIComponent(name)}`);
        return res.data;
    } catch (e) {
        console.log('fetchExtensionInfo error', e);
        return null;
    }
}

/**
 * Get extension package.json
 * 
 * @param {*} name 
 * @returns 
 */
export const getExtensionConfig = async (name) => {
    try {
        const instance = getAxios(null, { assetsURL: EXTENSION_ASSETS_URL });
        const resp = await instance.get(`/${name}/package.json`);
        return resp.data
    } catch (e) {
        return null;
    }
}


export const fetchStudentTermFeesComponents = async (token, schoolId, studentId, termStartEndId) => {
    try {
        const api = getFrisbee(token);
        return await api.get(`/api/schools/${schoolId}/student-term-fees-components/${termStartEndId}/students/${studentId}`);
    } catch (e) {

    }
}


export const postUploadStudentPhotos = async (token, schoolId, streamId, formData) => {
    const api = getFrisbee(token);
    return await api.post(`/api/schools/${schoolId}/students/bulk-photo-upload/${streamId}`, {
        body: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
